import {EngagementId, PaginationArgs, PopulationId, SampleId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const sample = typedQuery(["tprm", "sample", param<SampleId>("sampleId")], async sampleId => {
  return await api.tprm.samples.get(sampleId);
});

export const sampleItems = typedQuery(
  ["tprm", "sampleItems", param<SampleId>("sampleId"), param<PaginationArgs>("pagination")],
  async (sampleId, pagination) => {
    return await api.tprm.samples.listItems(sampleId, pagination);
  },
);

export const engagementSamples = typedQuery(
  ["tprm", "engagementSamples", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.samples.list(engagementId);
  },
);

export const populationSamples = typedQuery(
  ["tprm", "populationSamples", param<PopulationId>("populationId")],
  async populationId => {
    return await api.tprm.samples.listForPopulation(populationId);
  },
);
